import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Markdown } from 'uikit/content';

import styles from '../styles/formFieldHelp.module.scss';

const FormFieldHelp = ({ className = '', help = '' }) => {
  if (!help) return null;
  return <Markdown className={classnames(styles.element, className)} content={help} />;
};

FormFieldHelp.propTypes = {
  className: PropTypes.string,
  help: PropTypes.string,
};

export { FormFieldHelp as FormFieldHelpStorybook };
export default React.memo(FormFieldHelp);
